import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-9 mx-auto" }
const _hoisted_3 = { class: "table table-bordered mt-4 mb-5" }
const _hoisted_4 = { class: "table table-bordered mb-5" }
const _hoisted_5 = { class: "table table-bordered mb-5" }

import HeaderBanner from './HeaderBanner.vue';
import BulletPointList from '../common/BulletPointList.vue';
import { BulletListItem, BulletListIconStyle } from '@/guiide/ts/components/bulletListIconStyle';


export default /*@__PURE__*/_defineComponent({
  __name: 'RetirementChoicesHL',
  setup(__props) {

const annuityBenefits = new Array<BulletListItem>(
    { text: "Your income is guaranteed for life. This is true no matter how long you live or what the stock markets are doing." },
    { text: "You can choose options so your income increases. This means your buying power could keep up with inflation." },
    { text: "Your income could continue after you die if you've chosen certain options when you get quotes and apply." }
);
const annuityRisks = new Array<BulletListItem>(
    { text: "You can't change your options if your circumstances change." },
    { text: "You can't cash in your annuity." },
    { text: "Annuity rates might rise in the future, but you won't benefit from this if your annuity is already being paid." },
);

const drawdownBenefits = new Array<BulletListItem>(
    { text: "Withdraw what you want, when you want. So you keep your options open if your circumstances change." },
    { text: "Potentially beat inflation with returns from your investments. You could maintain your buying power as prices rise." },
    { text: "Pass on your money - when you die this can normally be paid as a lump sum or as income." },
);
const drawdownRisks = new Array<BulletListItem>(
    { text: "You could run out of money if you withdraw too much too soon, your investments don't perform as you'd hoped or you live longer than expected." },
    { text: "Income isn't secure, it could fall or even stop completely." },
    { text: "It's possible you'll get back less than you originally invested, as all investments can fall as well as rise in value." }
);

const lumpSumBenefits = new Array<BulletListItem>(
    { text: "Withdraw what you want, when you want. So you keep your options open if your circumstances change." },
    { text: "Potentially beat inflation with returns from your investments. You could maintain your buying power as prices rise." },
    { text: "Pass on your money - when you die this can normally be paid as a lump sum or as income." }
);
const lumpSumRisks = new Array<BulletListItem>(
    { text: "You could run out of money if you withdraw too much too soon, your investments don't perform as you'd hoped or you live longer than expected." },
    { text: "Income isn't secure, it could fall or even stop completely." },
    { text: "It's possible you'll get back less than you originally invested, as all investments can fall as well as rise in value." },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeaderBanner, { title: "Retirement choices" }),
    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "col-md-9 mx-auto" }, [
      _createElementVNode("div", { class: "row" }, [
        _createElementVNode("div", { class: "col-md-6" }, [
          _createElementVNode("iframe", {
            src: "https://www.youtube.com/embed/d0lyODJaEiU?si=JlR7yTOZ7yAA4U-u",
            class: "w-100 h-100",
            title: "YouTube video player",
            frameborder: "0",
            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
            referrerpolicy: "strict-origin-when-cross-origin",
            allowfullscreen: ""
          })
        ]),
        _createElementVNode("div", { class: "col-md-6" }, [
          _createElementVNode("h4", null, "What are my retirement options?"),
          _createElementVNode("p", null, "The earliest you can access your pension is usually 55 (rising to 57 from 2028)."),
          _createElementVNode("p", null, "It's up to you when you take it. And if you don't need the money yet, you can leave it for future. Below we compare the main retirement options for taking money for your pension."),
          _createElementVNode("p", null, [
            _createTextVNode("The government's free and impartial "),
            _createElementVNode("a", {
              href: "https://www.moneyhelper.org.uk/en/pensions-and-retirement/pension-wise",
              target: "_blank"
            }, "Pension Wise"),
            _createTextVNode(" service can help those aged 50 or over understand what type of pension they have, how to access their pension savings and the potential tax implications of each option.")
          ]),
          _createElementVNode("p", null, "Tax rules can change, and the benefits will depend on your own circumstances.")
        ])
      ]),
      _createElementVNode("div", { class: "row mt-4 mb-5" }, [
        _createElementVNode("div", { class: "col" }, [
          _createElementVNode("div", { class: "card" }, [
            _createElementVNode("div", { class: "card-header d-flex justify-content-between align-items-center" }, [
              _createElementVNode("h5", { class: "mb-0" }, "Read the video transcript"),
              _createElementVNode("button", {
                class: "btn btn-sm btn-primary",
                type: "button",
                "data-bs-toggle": "collapse",
                "data-bs-target": "#videoTranscript",
                "aria-expanded": "false",
                "aria-controls": "videoTranscript"
              }, " Read Transcript ")
            ]),
            _createElementVNode("div", {
              class: "card-body p-4 collapse",
              id: "videoTranscript"
            }, [
              _createElementVNode("div", {
                class: "collapse",
                id: "videoTranscript"
              }, [
                _createElementVNode("p", { class: "card-text" }, " What are my retirement options? Three ways of taking income from your pension explained. Animation and illustrations play on screen that highlights the phrases used in the voiceover. "),
                _createElementVNode("p", { class: "card-text" }, " \"You've been building up your retirement savings, and now might be the time when you're thinking of taking some money out. You'll probably want an income and you might want to take an initial lump sum. For example for some home improvements or to pay off some debt. But there are a number of ways you can do this, so it's worth taking the time to consider your options and see which ways will work best for you. "),
                _createElementVNode("p", { class: "card-text" }, " The earliest you can take your pension is age 55, rising to 57 from 2028. Usually you can take up to a quarter of it tax-free, with the rest taxed as income when you take it out. Here are three different ways you can take the money out of your pension.\" "),
                _createElementVNode("p", { class: "card-text" }, [
                  _createElementVNode("strong", null, "Annuities:")
                ]),
                _createElementVNode("p", { class: "card-text" }, " \"Some bills never stop so for peace of mind you could make sure that your essential expenditure is covered with a secure income. You always have the option to convert some or all of your pension savings to an annuity, which will pay you a guaranteed income for life. At the start you can choose different options, like inflation protection or a continuing income for your partner or spouse after your death. It's important to get quotes from the whole market as different providers will offer the best rates at different times and make sure you confirm health and lifestyle details as these can boost your income. "),
                _createElementVNode("p", { class: "card-text" }, " Annuities can't be changed once set up so you need to choose what's right for you and get the best deal you can. "),
                _createElementVNode("p", { class: "card-text" }, [
                  _createElementVNode("strong", null, "Drawdown:")
                ]),
                _createElementVNode("p", { class: "card-text" }, " \"With drawdown you keep your pension invested and draw an income whenever you need to. If your investments perform well and you don't take too much out you could enjoy a rising income. But the danger is you could run out of money if your investments perform poorly, you take out too much too early, or you live longer than expected. This means it's a higher risk option than an annuity so it won't be right for everyone.\" "),
                _createElementVNode("p", { class: "card-text" }, [
                  _createElementVNode("strong", null, "One-off lump sums:")
                ]),
                _createElementVNode("p", { class: "card-text" }, " \"With annuities and drawdown you take the tax-free cash at the start, with lump sums or uncrystallised funds pension lump sums to give them their full name, UFPLS for short, it's different. 25% of each lump sum is usually tax-free, with the rest taxable, while the remainder of your pension pot stays invested. This means the risks are more like a drawdown plan and it's a higher risk option than an annuity. "),
                _createElementVNode("p", { class: "card-text" }, " Important information - What you do with your pension is an important decision. You should check you're making the right decision for your circumstances and that you understand all your options and their risks. Tax rules can change over time and benefits depend on individal circumstances.\" "),
                _createElementVNode("p", { class: "card-text" }, " The government's free and impartial Pension Wise service can help you and we can offer you advice if you'd like it. The information in this video isn't personal advice. ")
              ])
            ])
          ])
        ])
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[6] || (_cache[6] = _createElementVNode("h4", null, " Compare your retirement options ", -1)),
        _cache[7] || (_cache[7] = _createElementVNode("p", null, " There are three main ways you can access your pension: by getting an annuity, moving money into drawdown and taking lump sums. You can also mix and match your retirement options, which could help you find the right balance of security and flexibility. ", -1)),
        _cache[8] || (_cache[8] = _createElementVNode("h4", null, " Annuities ", -1)),
        _cache[9] || (_cache[9] = _createElementVNode("p", null, " Swap money in your pension for a guaranteed income for the rest of your life. ", -1)),
        _createElementVNode("table", _hoisted_3, [
          _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { scope: "col" }, "Tax"),
              _createElementVNode("th", { scope: "col" }, "Benefits"),
              _createElementVNode("th", { scope: "col" }, "Risks")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _cache[0] || (_cache[0] = _createElementVNode("td", null, "You can usually take up to 25% tax-free cash at the start. Your income is taxable.", -1)),
              _createElementVNode("td", null, [
                _createVNode(BulletPointList, {
                  items: _unref(annuityBenefits),
                  "icon-style": _unref(BulletListIconStyle).Tick
                }, null, 8, ["items", "icon-style"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(BulletPointList, {
                  items: _unref(annuityRisks),
                  "icon-style": _unref(BulletListIconStyle).Cross
                }, null, 8, ["items", "icon-style"])
              ])
            ])
          ])
        ]),
        _cache[10] || (_cache[10] = _createElementVNode("h4", null, " Drawdown ", -1)),
        _cache[11] || (_cache[11] = _createElementVNode("p", null, " Keep your pension invested. Take the income you want, when you want. ", -1)),
        _createElementVNode("table", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { scope: "col" }, "Tax"),
              _createElementVNode("th", { scope: "col" }, "Benefits"),
              _createElementVNode("th", { scope: "col" }, "Risks")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _cache[2] || (_cache[2] = _createElementVNode("td", null, "You can usually take up to 25% tax-free cash at the start. Any income you withdraw is taxable.", -1)),
              _createElementVNode("td", null, [
                _createVNode(BulletPointList, {
                  items: _unref(drawdownBenefits),
                  "icon-style": _unref(BulletListIconStyle).Tick
                }, null, 8, ["items", "icon-style"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(BulletPointList, {
                  items: _unref(drawdownRisks),
                  "icon-style": _unref(BulletListIconStyle).Cross
                }, null, 8, ["items", "icon-style"])
              ])
            ])
          ])
        ]),
        _cache[12] || (_cache[12] = _createElementVNode("h4", null, " Lump sums ", -1)),
        _cache[13] || (_cache[13] = _createElementVNode("p", null, " Keep your pension invested. Take the lump sums you want, when you want. ", -1)),
        _createElementVNode("table", _hoisted_5, [
          _cache[5] || (_cache[5] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { scope: "col" }, "Tax"),
              _createElementVNode("th", { scope: "col" }, "Benefits"),
              _createElementVNode("th", { scope: "col" }, "Risks")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _cache[4] || (_cache[4] = _createElementVNode("td", null, "Usually, 25% of each withdrawal is tax-free, and the rest is taxable.", -1)),
              _createElementVNode("td", null, [
                _createVNode(BulletPointList, {
                  items: _unref(lumpSumBenefits),
                  "icon-style": _unref(BulletListIconStyle).Tick
                }, null, 8, ["items", "icon-style"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(BulletPointList, {
                  items: _unref(lumpSumRisks),
                  "icon-style": _unref(BulletListIconStyle).Cross
                }, null, 8, ["items", "icon-style"])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})